import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=336fb23c&scoped=true&"
import script from "./LinkExpired.vue?vue&type=script&lang=js&"
export * from "./LinkExpired.vue?vue&type=script&lang=js&"
import style0 from "./LinkExpired.vue?vue&type=style&index=0&id=336fb23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336fb23c",
  null
  
)

component.options.__file = "LinkExpired.vue"
export default component.exports